import { IsDefined, IsNotEmpty, IsString, MaxLength } from 'class-validator';

export class FunctionBaseApiModel {
  @IsString()
  @IsDefined()
  @MaxLength(50)
  @IsNotEmpty()
  name!: string;
}
